import { Circle, Image } from 'react-konva';
import React, { useRef } from 'react';

import Konva from 'konva';
import fan_green from '../../../assets/images/fan-blades-green.png';
import useImage from 'use-image';

const TrafficLight = ({
  arrIndexPump,
  arrIndexFloat,
  item,
  handleContextMenu,
  disableTrafficLight
}) => {
  let indexPump, indexVf, indexVan, indexLight;
  if (item.type === 'pump') {
    indexPump = arrIndexPump.find((elm) => elm[0].index === item.number);
  } else if (item.type === 'vf') {
    indexVf = arrIndexPump.find((elm) => elm[0].index === item.number);
  } else if (item.type === 'van') {
    indexVan = arrIndexPump.find((elm) => elm[0].index === item.number);
  } else if (item.type === 'light') {
    indexLight = arrIndexFloat.find((elm) => elm[0].index === item.number);
  }

  const [imageGreen] = useImage(fan_green);
  let refFan = useRef();
  var rect = refFan.current;

  if ((indexPump || indexVf) && !disableTrafficLight) {
    var angularSpeed = 10;
    var anim = new Konva.Animation((frame) => {
      var angleDiff = (frame.timeDiff * angularSpeed) / 1000;
      rect?.rotate(angleDiff);
    }, rect?.getLayer());
    anim.start();
  }

  return indexPump || indexVf ? (
    <Image
      width={20}
      height={20}
      ref={refFan}
      offsetX={10}
      offsetY={10}
      x={14}
      y={indexPump ? 13 : 16}
      image={imageGreen}
      onContextMenu={(e) => handleContextMenu(e, item.topLeftPoint.x)}
    />
  ) : item.type === 'van' ? (
    <Circle
      x={13}
      y={13}
      radius={8}
      strokeWidth={1}
      stroke="black"
      fill={indexVan ? 'green' : 'red'}
    />
  ) : item.type === 'light' ? (
    <Circle
      x={13}
      y={13}
      radius={8}
      strokeWidth={1}
      stroke="black"
      fill={indexLight ? 'green' : 'red'}
    />
  ) : (
    <Circle x={10} y={6} radius={0} strokeWidth={1} stroke="black" fill="red" />
  );
};

export default TrafficLight;
